import axios from 'axios';
// Make sure this matches your backend URL exactly (including http:// and port)
const BASE_URL = process.env.REACT_APP_PUBLIC_API_BASE_URL || 'http://161.97.114.240:8888/api';
class ApiClient {
  constructor() {
    this.instance = axios.create({
      baseURL: BASE_URL,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      withCredentials: true, // This is important for sending cookies with CORS
      xsrfCookieName: 'csrftoken',
      xsrfHeaderName: 'X-CSRFToken',
    });

    this.initializeInterceptors();
  }

  initializeInterceptors() {
    // Request interceptor
    this.instance.interceptors.request.use(
      (config) => {
        // You can add auth tokens here
        const token = localStorage.getItem('access_token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Response interceptor
    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        // Handle common errors here (e.g., 401, 403, 500)
        if (error.response) {
          switch (error.response.status) {
            case 401:
              // Handle unauthorized
              localStorage.removeItem('access_token');
              window.location.href = '/login';
              break;
            case 403:
              // Handle forbidden
              break;
            case 404:
              // Handle not found
              break;
            case 500:
              // Handle server error
              break;
            default:
              console.error('Unhandled error status:', error.response.status);
          }
        }
        return Promise.reject(error);
      }
    );
  }

  // HTTP Methods
  async get(url, config) {
    const response = await this.instance.get(url, config);
    return response.data;
  }

  async post(url, data, config) {
    const response = await this.instance.post(url, data, config);
    return response.data;
  }

  async put(url, data, config) {
    const response = await this.instance.put(url, data, config);
    return response.data;
  }

  async delete(url, config) {
    const response = await this.instance.delete(url, config);
    return response.data;
  }

  async patch(url, data, config) {
    const response = await this.instance.patch(url, data, config);
    return response.data;
  }
}

export const apiClient = new ApiClient();
